import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { SolutionOutlined } from '@ant-design/icons';
import { t } from '../../../../i18n';
import FeedbackModal from '../../../common/modals/FeedbackModal/FeedbackModal';
import Tooltip from '../../../common/Tooltip/Tooltip';

const FeedBack = ({ isExpanded }) => {
  const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);
  return (
    <>
      <div className="sidebar-feedback-container">
        <Tooltip tooltip={isExpanded ? undefined : t('Nahlásenie chyby')} right>
          <SolutionOutlined
            onClick={() => {
              setIsFeedbackOpen(true);
            }}
          />
        </Tooltip>
        {isExpanded && (
          <div
            className="name-container"
            onClick={() => {
              setIsFeedbackOpen(true);
            }}
          >
            {t('Nahlásenie chyby')}
          </div>
        )}
      </div>
      <FeedbackModal isOpen={isFeedbackOpen} setIsOpen={setIsFeedbackOpen} />
    </>
  );
};

FeedBack.propTypes = {
  isExpanded: PropTypes.bool.isRequired,
};

export default FeedBack;
